import React from "react";
const StatisticsUpdateContext = React.createContext();
  
const { 
  Provider : StatisticsUpdateContextProvider, 
  Consumer : StatisticsUpdateContextConsumer 
} = StatisticsUpdateContext;
export { StatisticsUpdateContext, StatisticsUpdateContextProvider, StatisticsUpdateContextConsumer };